export function convertToNumber(value, decimalPlaces = null) {
  // Handle empty/null/undefined cases
  if (value === null || value === undefined || value === '') {
    return 0;
  }

  // If already a number, apply decimal places if specified
  if (typeof value === 'number') {
    return decimalPlaces !== null ? Number(value.toFixed(decimalPlaces)) : value;
  }

  // Convert to string if not already and trim whitespace
  const stringValue = String(value).trim();

  // Remove commas from the string
  const normalizedValue = stringValue.replace(/,/g, '');

  // Check if it's a valid number format using regex
  // Allows: integers, decimals, negative numbers
  // Disallows: exponential notation, infinity, alphabets
  if (!/^-?\d*\.?\d+$/.test(normalizedValue)) {
    return false;
  }

  // Convert to number
  const number = Number(normalizedValue);

  // Additional validation using Number methods instead of globals
  if (Number.isNaN(number) || !Number.isFinite(number)) {
    return false;
  }

  // Apply decimal places if specified
  return decimalPlaces !== null ? Number(number.toFixed(decimalPlaces)) : number;
}
